
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swipe",
      function () {
        return require("private-next-pages/swipe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swipe"])
      });
    }
  